import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import { useIntl } from 'react-intl';
import { Tooltip } from '@mui/material';

const useStyles = makeStyles(theme => ({
  icon: {
    fontSize: '16px !important',
    marginLeft: theme.spacing(0.5),
    color: theme.palette.error.main
  }
}));

const BusyIcon = ({ requestLoad, availabilityPercentage }) => {
  const intl = useIntl();
  const classes = useStyles();

  const isBusy = availabilityPercentage < requestLoad;

  const tooltipMessage = intl.formatMessage({
    id: 'busyIcon.notEnoughAvailableHours'
  });

  return isBusy ? (
    <Tooltip title={tooltipMessage}>
      <span role="img" aria-label={tooltipMessage}>
        <EventBusyIcon className={classes.icon} aria-hidden="true" />
      </span>
    </Tooltip>
  ) : null;
};

BusyIcon.propTypes = {
  requestLoad: PropTypes.number.isRequired,
  availabilityPercentage: PropTypes.number.isRequired
};

export default BusyIcon;
